import { createSlice } from '@reduxjs/toolkit'

export const LoadingReducer = createSlice({
    name: 'loading',
    initialState: {
        isLoading: false,
    },
    reducers: {
        startLoading: (state, action) => {
            state.isLoading = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { startLoading } = LoadingReducer.actions

export default LoadingReducer.reducer